import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { pricingApi } from "@/api/pricing.api";
import { queryKeys } from "@/utils/queryKeys";
import type { PricingRule } from "@/types/domain";

/** GET /pricing/rules — every configured rule ('default' + one per zone). */
export function usePricingRules() {
  return useQuery({
    queryKey: queryKeys.pricing.rules(),
    queryFn: () => pricingApi.listRules(),
  });
}

export function useUpdatePricingRule() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ key, payload }: { key: string; payload: Partial<PricingRule> }) =>
      pricingApi.updateRule(key, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.pricing.rules() });
    },
  });
}

export function useCreatePricingRule() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ key, payload }: { key: string; payload: Partial<PricingRule> }) =>
      pricingApi.createRule(key, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.pricing.rules() });
    },
  });
}
